import React, { useMemo, useRef } from 'react';
import cn from 'classnames';
import { Select } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import Icon, { CheckedIcon, CloseIcon } from 'components/Atoms/Icon';
import PropTypes from 'prop-types';
import './styles.scss';
import Image from '../Image';

const MySelect = (props) => {
  const onChange = props.onChange;

  const selectRef = useRef(null);

  const onClearValue = () => {
    onChange('');
    props.onSelect('');
  };

  const handleChange = (value) => {
    onChange(!props.myLabel ? value : value.value);
    props.onSelect(!props.myLabel ? value : value.value);
  };

  const filterOption = (input, option) =>
    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  const valueLabel = useMemo(() => {
    if (!props.myLabel) return '';
    const el = props.options.find(
      (option, i) => option[props.valueKey] === props.value
    );
    if (el) {
      return el[props.labelKey];
    }
    return '';
  }, [props.value, props.options]);

  return (
    <div id="my-select">
      <Select
        disabled={props.disabled}
        showSearch={props.showSearch}
        onChange={handleChange}
        ref={selectRef}
        id="select-focus"
        mode={props.mode}
        open={props.open}
        // onInput
        size="large"
        placeholder={props.placeholder}
        className={cn(`${props.className || 'select-custom'}`, {
          tags: props.mode === 'tags',
        })}
        labelInValue={props.myLabel}
        value={
          !props.myLabel
            ? props.value || undefined
            : {
                value: props.value || undefined,
                label: (
                  <span>
                    {props.renderValue ? (
                      <>
                        <span className="my-label">{props.myLabel}</span>
                        {props.renderValue(valueLabel)}
                      </>
                    ) : (
                      <span className="my-label-value">{valueLabel}</span>
                    )}
                  </span>
                ),
              }
        }
        clearIcon={
          <CloseIcon className="icon-clear-custom" width={14} height={14} />
        }
        suffixIcon={
          props.disabled ? null : (
            <CaretDownOutlined className="icon-caret-custom" />
          )
        }
        onClear={onClearValue}
        dropdownMatchSelectWidth={false}
        allowClear={props.allowClear}
        filterOption={filterOption}
        showAction={['focus', 'click']}
        defaultValue={props.mode === 'tags' ? undefined : props.defaultValue}
        tagRender={props.tagRender}
      >
        {props.options.map((option, idx) => {
          return (
            <Select.Option
              key={`${option[props.valueKey]}-${option[props.value]}` || idx}
              value={option[props.valueKey]}
              label={option[props.labelKey]}
              className="my-select-option my-select-custom-item"
            >
              {props.renderItem ? (
                <div className="my-select-custom-item">
                  {props.renderItem(option)}
                </div>
              ) : (
                <>
                  {option.icon && (
                    <Image
                      src={option.icon}
                      className="my-select-option-icon"
                    />
                  )}
                  <span className="my-select-text">
                    {option[props.labelKey]}
                  </span>
                </>
              )}
              <Icon
                component={CheckedIcon}
                className="my-select-selected-icon"
              />
            </Select.Option>
          );
        })}
      </Select>
      <div id="select-dropdown-container" />
    </div>
  );
};

MySelect.propTypes = {
  size: PropTypes.string,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  placeholder: PropTypes.string,
  name: PropTypes.string,
  showSearch: PropTypes.bool,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
  suffixIcon: PropTypes.any,
  allowClear: PropTypes.bool,
  className: PropTypes.string,
  renderItem: PropTypes.func,
  renderValue: PropTypes.func,
  defaultValue: PropTypes.string,
};

MySelect.defaultProps = {
  placeholder: 'Please select',
  labelKey: 'name',
  valueKey: 'id',
  size: 'large',
  options: [
    { name: 'Option 1', id: 1 },
    { name: 'Option 2', id: 2 },
    { name: 'Option 3', id: 3 },
  ],
  name: 'fieldName',
  showSearch: false,
  onSelect: () => null,
  disabled: false,
  allowClear: false,
  defaultValue: null,
};

export default MySelect;
